export const formatToPath = text =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^\w ]/g, '')
    .replace(/\s+/g, '-');
